module.exports = __webpack_public_path__ + "media/images/mock-thumbs/product-2-eea6172c6bdce3bbf88746ce383e388d.png";